// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"745":"9f607d13","963":"9f607d13"}[chunkId] + ".chunk.css";
};